import { createStore, combineReducers, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'
import postsReducer from './features/Posts/postsReducer'
import authReducer from './features/Auth/authReducer'
import profileReducer from './features/Profile/profileReducer'
import preferencesReducer from './features/Profile/preferenceReducer'
import { registerReducer } from './features/Register/registerReducer'
import swipeReducer from './features/Swipe/swipeReducer'
import favoritesReducer from './features/Favorites/favoritesReducer'
import appointmentsReducer from './features/Appointments/appointmentsReducer'

const rootReducer = combineReducers({
  posts: postsReducer,
  auth: authReducer,
  profile: profileReducer,
  preferences: preferencesReducer,
  register: registerReducer,
  swipe: swipeReducer,
  favorites: favoritesReducer,
  appointments: appointmentsReducer
})

const store = createStore(rootReducer, applyMiddleware(thunk))
export default store
